export const ITEM_IDENTIFIERS = [
  { id: 'ivgCode', name: 'Codice IVG' },
  { id: 'ivgCodePlusId', name: 'Codice IVG + ID lotto' },
];

export const LINK_TYPES_CHOICES = [
  { id: 'page', name: 'Pagina' },
  { id: 'url', name: 'URL' },
];
